export default __webpack_public_path__ + "static/media/agriculture_right.60b2341b.png";